import React from 'react';
import { AnimatedButton } from '../../button/Animated';
import { NatureButton } from '../../button/Nature';
import { SquareButton, SquareButtonProps } from '../../button/Squares';

export interface BackgroundSwitchProps extends SquareButtonProps {
  access: boolean;
}

export const BackgroundSwitcher: React.FC<BackgroundSwitchProps> = ({
  access,
  className,
}) => {
  return (
    <React.Fragment>
      <div className={className.btnContainer}>
        <NatureButton className={className} />
      </div>

      <div className={className.btnContainer}>
        <SquareButton className={className} />
      </div>

      <div className={className.btnContainer}>
        <AnimatedButton className={className} />
      </div>
      {/* 
      {!access && (
        <div className={className.btnContainer}>
          <IframeButton className={className} />
        </div>
      )} */}

      {/*Restore when we have plain theme for light and darkMode*/}
      {/* <div className={className.btnContainer}>
        <ThemeSwitcher className={className} />
      </div> */}
    </React.Fragment>
  );
};
